export const showModal = (modalType, modalProps, options = {}) => ({
  type: 'ROOT/SHOW_MODAL',
  modalType,
  modalProps,
  options,
});

export const hideModal = modalType => ({ type: 'ROOT/HIDE_MODAL', modalType });

export const refreshModalProps = (modalProps, modalType) => ({
  type: 'ROOT/REFRESH_MODAL_PROPS',
  modalProps,
  modalType,
});
